import React, {useEffect} from "react";
import {getShortDate} from "../../Util/TableHelpers/commonHelper";
import {useDispatch, useSelector} from "react-redux";
import {getLast6Months} from "../../Util/TableHelpers/storeUsageHelper";
import {STORE_USAGE_MONTH} from "../../Reducers/storeUsageMonthReducer";

const MonthSelector = () => {
    const billingDataObj = useSelector(state => state.partnerBillingData);
    const dispatch = useDispatch();

    useEffect(() => {
        if (billingDataObj !== null)
            dispatch({
                type: STORE_USAGE_MONTH,
                payload: getLast6Months(Object.keys(billingDataObj.billingFormattedObj))[0]
            });
    }, [billingDataObj]);

    const getOptions = () => {
        let monthList = getLast6Months(Object.keys(billingDataObj.billingFormattedObj));
        return monthList.map((month, ind) => {
            let dateObj = new Date(month);
            return <option key={ind} value={month}>{getShortDate(dateObj)}</option>;
        })
    }

    const handleChange = (ev) => {
        dispatch({
            type: STORE_USAGE_MONTH,
            payload: ev.target.value
        });
    }

    if (billingDataObj === null) return <></>;

    return (
        <select className="month-selector" onChange={handleChange}>
            {getOptions()}
        </select>
    )
}

export default MonthSelector;

